const extractRequestTypeSegment = (pathname: string): string | null => {
  const pathnameSegments = pathname.split('/');

  // {}/{ess}/{manage-requests}/{salary-certificate} - extract salary-certificate
  const requestType = pathnameSegments[3];

  return requestType || null;
};

export const extractRequestTypeCode = (
  pathname: string,
  RequestPathPerType: Record<string, string>
): string | null => {
  const requestTypeSegment = extractRequestTypeSegment(pathname);

  if (!requestTypeSegment) {
    return null;
  }

  const requestTypeCode = RequestPathPerType[requestTypeSegment];

  return requestTypeCode || null;
};
